import { InjectionToken } from '@angular/core';

/**
 * Token de injeção para a URL da API de planejamento de aula
 * Deve ser fornecido no módulo raiz da aplicação com o valor do environment
 */
export const PLANO_AULA_API_URL = new InjectionToken<string>(
  'PLANO_AULA_API_URL',
);
